import { LayoutType } from "core/constants";
import { GridDataContextProvider } from "core/providers/grid-data-context";
import TVGuideGrid from "./tv-guide-grid";
import TVGuideList from "./tv-guide-list";
import { observer } from "mobx-react-lite";
import { AppContext } from "core/providers/tv-guide.context";
import { useContext } from "react";

const Layout = observer(() => {

    const appContext = useContext(AppContext);
    const store = appContext.store;

    switch (store.layout) {
        case LayoutType.grid:
            return (<GridDataContextProvider>
                <TVGuideGrid />
            </GridDataContextProvider>);

        case LayoutType.list:
            return (<TVGuideList />);

        default:
            return null;
    }
});

export default Layout;